import type { AppNavItem } from '@/lib/navigation/app-nav-types';

/**
 * Nav arrays are reverse-display: index 0 is last on the SaaS tab strip
 * (and the sidebar bottom after `.reverse()`). Super-admin-only tabs belong there.
 */
export function placeSuperAdminNavItemsLast(items: AppNavItem[]): AppNavItem[] {
  const adminTabs = items.filter((item) => item.superAdminOnly);
  if (adminTabs.length === 0) return items;
  return [...adminTabs, ...items.filter((item) => !item.superAdminOnly)];
}
